import React from 'react';
import { Box, Stat, StatLabel, StatNumber, StatHelpText, Icon, HStack } from '@chakra-ui/react';
import type { IconType } from 'react-icons';

interface Props {
  label: string;
  value: string;
  helpText?: string;
  icon?: IconType;
  accent?: string;
}

export const StatCard: React.FC<Props> = ({ label, value, helpText, icon, accent = 'brand.500' }) => (
  <Box bg="white" borderWidth="1px" rounded="lg" p={4} shadow="xs">
    <Stat>
      <HStack justify="space-between" align="start">
        <StatLabel color="gray.500" fontSize="xs" textTransform="uppercase" letterSpacing="wide">
          {label}
        </StatLabel>
        {icon && <Icon as={icon} color={accent} boxSize={4} />}
      </HStack>
      <StatNumber fontSize="2xl" mt={1}>
        {value}
      </StatNumber>
      {helpText && <StatHelpText mb={0}>{helpText}</StatHelpText>}
    </Stat>
  </Box>
);
